import React from 'react';
import { Handle, Position } from '@xyflow/react';

import { usePromoPanel } from '../context';
import { Card, HeaderRow, NoDrag, Pill } from './nodes.styles';

/**
 * The on-canvas control card: the promotion picker, a free-text prompt that steers the LLM compose, and the
 * Regenerate action, tied by a connector to the key visual (F0). Its content is supplied by the composer
 * through {@link usePromoPanel} (NOT node data), so the live prompt value reaches the textarea without React
 * Flow's one-render node-data lag, which would otherwise reset the caret mid-type. Wrapped in NoDrag so
 * editing never pans or zooms the board.
 */
export const PromoNode = (): React.ReactElement => {
  const content = usePromoPanel();
  return (
    <Card $width={300}>
      <HeaderRow>
        <Pill text="Setup" />
      </HeaderRow>
      <NoDrag>{content}</NoDrag>
      <Handle type="source" position={Position.Right} />
    </Card>
  );
};

export default PromoNode;
